import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import { apiV2EnergyOverviewGetWorkOrderDetailPost } from '@maxtropy/device-customer-apis-v2';
import titlePng from '@/assets/images/title_icon.png';

import { TaskScene, TaskSceneColors, TaskSceneDisplay, TaskSceneImg } from '../../../../const';
import styles from './index.module.scss';
import { useContext, useMemo, useRef } from 'react';
import { getBarChartOption } from './chart';
import { isEmpty } from 'lodash-es';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { useBarAutoLoop } from '../AlarmArea/hook';
import { Spin } from 'antd';

const WorkOrder = () => {
  const theme = useTheme();
  const { timeResolution, dateValue } = useContext(ShareDataUnityEnergyCockpitMapContext);
  const chartRef = useRef(null);

  const { data: workOrderDetail, loading } = useRequest(
    async () => {
      return await apiV2EnergyOverviewGetWorkOrderDetailPost({
        timeResolution,
        fromTime: getDefaultTime(timeResolution!, dateValue)?.startTime,
        toTime: getDefaultTime(timeResolution!, dateValue)?.endTime,
      });
    },
    {
      refreshDeps: [timeResolution, dateValue],
      ready: !!timeResolution && !!dateValue,
    }
  );

  // useBarAutoLoop(chartRef, {
  //   length: workOrderDetail?.chartDetail?.length ?? 0,
  // });

  const chartBarOption = useMemo(() => getBarChartOption(workOrderDetail?.chartDetail), [workOrderDetail]);

  return (
    <SubTitle title="工单趋势" img={titlePng} style={{ paddingTop: 12 }}>
      <Spin spinning={loading}>
        <div className={styles.workOrderWrapper}>
          <div className={styles.workOrderList}>
            {[workOrderDetail?.electricTotalNum, workOrderDetail?.waterTotalNum, workOrderDetail?.gasTotalNum].map(
              (item, index) => (
                <div key={index} className={styles.workOrderItem}>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 4,
                      height: '100%',
                      marginRight: 8,
                      background: TaskSceneColors[(index + 1) as TaskScene],
                    }}
                  ></span>
                  <img src={TaskSceneImg[(index + 1) as TaskScene]} alt="" width={32} />
                  {TaskSceneDisplay[(index + 1) as TaskScene]}
                  <div className={styles.line} />
                  <span style={{ color: '#52E7FF' }}>{item}</span>
                </div>
              )
            )}
          </div>
          <div className={styles.workOrderTrend}>
            <EchartsWithTheme
              option={chartBarOption}
              ref={chartRef}
              empty={{
                isShowEmpty: isEmpty(workOrderDetail?.chartDetail),
                emptyNode: <Empty imageStyle={{ height: 70 }} style={{ marginTop: 10 }} />,
              }}
              theme={theme}
              style={{ height: '100%', width: '100%', minHeight: 140 }}
              params={{
                dataZoomExit: true,
              }}
            />
          </div>
        </div>
      </Spin>
    </SubTitle>
  );
};

export default WorkOrder;
